import type { AxiosRequestConfig } from 'axios'

export const DefaultAxiosRequestSettings: AxiosRequestConfig = {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json, text/plain, */*',
  },
  params: {},
  withCredentials: true,
  timeout: 60e3,
}
